module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "commissionDatum"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commission.enable),
      expression: "commission.enable"
    }],
    staticClass: "enable-btn",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.version == '0'
    },
    domProps: {
      "checked": Array.isArray(_vm.commission.enable) ? _vm._i(_vm.commission.enable, null) > -1 : (_vm.commission.enable)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.commission.enable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.commission, "enable", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.commission, "enable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.commission, "enable", $$c)
        }
      }
    }
  }), _vm._v(" \n        "), _c('span', {
    staticClass: "enable-text"
  }, [_vm._v(_vm._s(_vm.multiLanguage.enable))])]), _vm._v(" "), _c('span', {
    staticClass: "table-title"
  }, [_vm._v(_vm._s(_vm.multiLanguage.ibCommissionSetting) + " "), (_vm.version == '1') ? _c('span', [_vm._v("(" + _vm._s(_vm.commission.isConfirm ? _vm.multiLanguage.confirmed : _vm.multiLanguage.unconfirmed) + ")")]) : _vm._e()]), _vm._v(" "), (_vm.templateLang) ? _c('div', {
    staticClass: "template-box"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.templateName) + ": ")]), _vm._v(" "), _c('span', {
    staticClass: "enable-text"
  }, [_vm._v(_vm._s(_vm.templateLang))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-box pull-right"
  }, [(_vm.version == '1') ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.verify
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-ok"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.check) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.version == '1') ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.submit
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-edit"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.submit) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.version == '1') ? _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.pageInit('0')
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-repeat"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.backData) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commission.isSpecial),
      expression: "commission.isSpecial"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.commission.isSpecial) ? _vm._i(_vm.commission.isSpecial, null) > -1 : (_vm.commission.isSpecial)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.commission.isSpecial,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.commission, "isSpecial", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.commission, "isSpecial", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.commission, "isSpecial", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#F08712",
      "font-weight": "700",
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.specialCommission))])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "last-update-box"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.multiLanguage.updateBy) + " : " + _vm._s(_vm.commission.updateBy) + " "), (_vm.commission.lastUpdate) ? _c('span', [_vm._v("(" + _vm._s(_vm.commission.lastUpdate) + ")")]) : _vm._e()]), _vm._v(" "), (true) ? _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.confirmBy) + " : " + _vm._s(_vm.commission.confirmBy) + " "), (_vm.commission.lastConfirm) ? _c('span', [_vm._v("(" + _vm._s(_vm.commission.lastConfirm) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "cpa-switch-box"
  }, [_c('div', {
    staticClass: "cpa-switch pull-left"
  }, [_c('btn', {
    staticClass: "internal",
    class: {
      'active': _vm.mode == 0 && _vm.commission.enable
    },
    attrs: {
      "disabled": !_vm.commission.enable || _vm.version == '0'
    },
    on: {
      "click": function($event) {
        _vm.mode = 0
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.multiLanguage.commonCaculation) + "\n        ")]), _vm._v(" "), (_vm.commission.cpa !== 'not exist') ? _c('btn', {
    staticClass: "CPA",
    class: {
      'active': _vm.mode == 1 && _vm.commission.enable
    },
    attrs: {
      "disabled": !_vm.commission.enable || _vm.version == '0'
    },
    on: {
      "click": function($event) {
        _vm.mode = 1
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.multiLanguage.CPACaculation) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.commission.cpa !== 'not exist') ? _c('btn', {
    staticClass: "internalAndCPA",
    class: {
      'active': _vm.mode == 2 && _vm.commission.enable
    },
    attrs: {
      "disabled": !_vm.commission.enable || _vm.version == '0'
    },
    on: {
      "click": function($event) {
        _vm.mode = 2
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.multiLanguage.comAndCPA) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "preinstall-box pull-right",
    style: (_vm.version == '0' ? 'visibility:hidden;' : '')
  }, [_c('Dropdown', {
    attrs: {
      "menu-right": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "data-role": "trigger",
      "type": "button",
      "disabled": !_vm.commission.enable || _vm.version == '0'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.SettingTemplate))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('template', {
    slot: "dropdown"
  }, _vm._l((_vm.ibTemplate), function(item, index) {
    return (item.isDisplay) ? _c('li', {
      on: {
        "click": function($event) {
          return _vm.normSetFn(item.templateId, 'ib')
        }
      }
    }, [_c('a', [_vm._v(_vm._s(_vm.multiLanguage[item.langKey] || item.templateId))])]) : _vm._e()
  }), 0)], 2), _vm._v(" "), (_vm.commission.cpa !== 'not exist') ? _c('Dropdown', {
    attrs: {
      "menu-right": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "data-role": "trigger",
      "type": "button",
      "disabled": !_vm.commission.enable || _vm.version == '0'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.cpa_SettingTemplate))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('template', {
    slot: "dropdown"
  }, _vm._l((_vm.cpaTemplate), function(item, index) {
    return (item.isDisplay) ? _c('li', {
      on: {
        "click": function($event) {
          return _vm.normSetFn(item.templateId, 'cpa')
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(_vm.multiLanguage[item.langKey]))])]) : _vm._e()
  }), 0)], 2) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), (_vm.mode == 0 || _vm.mode == 2) ? _c('internal-commission', {
    ref: "internalCommission",
    attrs: {
      "commission": _vm.commission,
      "groupSeq": _vm.groupSeq,
      "multiLanguage": _vm.multiLanguage,
      "version": _vm.version,
      "viewBtn": _vm.viewBtn
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mode == 1 || _vm.mode == 2) ? _c('cpa-commission', {
    ref: "cpaCommission",
    style: (_vm.mode == '2' ? 'margin-top:10px' : ''),
    attrs: {
      "commission": _vm.commission,
      "multiLanguage": _vm.multiLanguage,
      "version": _vm.version,
      "viewBtn": _vm.viewBtn
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "expired-box"
  }, [_c('div', {
    staticClass: "pull-left ReminderDate"
  }, [_c('h4', [_vm._v(_vm._s(_vm.multiLanguage.reminderDate))]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "disabled": !_vm.commission.enable || _vm.version == '0',
      "placeholder": _vm.multiLanguage.choiceDateTime
    },
    on: {
      "change": function($event) {
        _vm.timeIsChange = true
      }
    },
    model: {
      value: (_vm.commission.ReminderDate),
      callback: function($$v) {
        _vm.$set(_vm.commission, "ReminderDate", $$v)
      },
      expression: "commission.ReminderDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right ReminderMsg"
  }, [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.multiLanguage.reminderMsg))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.commission.sendEml),
      expression: "commission.sendEml"
    }],
    staticClass: "pull-left text-success send-eml"
  }, [_vm._v(_vm._s(_vm.multiLanguage.sented))]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "disabled": !_vm.commission.enable || _vm.version == '0',
      "placeholder": _vm.multiLanguage.reminderMsgPlaceholder
    },
    on: {
      "change": function($event) {
        _vm.timeIsChange = true
      }
    },
    model: {
      value: (_vm.commission.ReminderMsg),
      callback: function($$v) {
        _vm.$set(_vm.commission, "ReminderMsg", $$v)
      },
      expression: "commission.ReminderMsg"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commission.enableUpperCalc),
      expression: "commission.enableUpperCalc"
    }],
    staticClass: "enable-btn",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.version == '0'
    },
    domProps: {
      "checked": Array.isArray(_vm.commission.enableUpperCalc) ? _vm._i(_vm.commission.enableUpperCalc, null) > -1 : (_vm.commission.enableUpperCalc)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.commission.enableUpperCalc,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.commission, "enableUpperCalc", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.commission, "enableUpperCalc", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.commission, "enableUpperCalc", $$c)
        }
      }
    }
  }), _vm._v(" \n      "), _c('span', {
    staticClass: "enable-text"
  }, [_vm._v(_vm._s(_vm.multiLanguage.enable))])]), _vm._v(" "), _c('span', {
    staticClass: "table-title"
  }, [_vm._v(_vm._s(_vm.multiLanguage.upperCommissiondistribution))])]), _vm._v(" "), _c('div', [_c('rule-setting', {
    ref: "ruleSetting",
    attrs: {
      "enableUpperCalc": _vm.commission.enableUpperCalc,
      "multiLanguage": _vm.multiLanguage,
      "groupSeq": _vm.groupSeq,
      "version": _vm.version,
      "relation": _vm.relation,
      "currentIB": _vm.currentIB,
      "rule": _vm.rule,
      "ruleSeq": _vm.ruleSeq,
      "viewBtn": _vm.viewBtn
    },
    on: {
      "checkId": _vm.checkIdFn
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "size": "sm",
      "header": false,
      "footer": false
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sucSave),
      expression: "!sucSave"
    }]
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-warning-sign color-red"
  }), _vm._v(" "), _c('span', {
    staticClass: "color-red"
  }, [_vm._v(_vm._s(_vm.multiLanguage.submitResult.err))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sucSave),
      expression: "sucSave"
    }]
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-ok color-green"
  }), _vm._v(" "), _c('span', {
    staticClass: "color-green"
  }, [_vm._v(_vm._s(_vm.multiLanguage.submitResult.succeed))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08d221a1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommissionSetting2/IB/IBSetting/ibCommissionSettingContent.vue
// module id = 1069
// module chunks = 1